import React from "react";
import styled from "styled-components";
import moment from "moment";
import { MenuItem, Typography } from "@mui/material";
import ArrowRightIcon from "src/assets/arrow-right.png";

const Wrapper = styled.div`
  .MuiMenuItem-root {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #ebebeb;
    .img-wrapper {
      width: 25vw;
      height: 25vw;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .coupon_title {
    word-break: break-all;
    white-space: pre-wrap;
    color: #7b7c7e;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    width: calc(75vw - 55px);
    word-break: normal;
    > h6 {
      font-size: 20px;
      line-height: 1.3;
      margin-bottom: 20px;
    }
  }
  .coupon_tag {
    background-color: #7b7c7e;
    color: #fff;
    padding: 2px 5px;
    font-size: 1rem;
    margin-right: 5px;
  }
  .time_range {
    font-size: 1rem;
  }
`;

const CouponListItem = ({
  startTime,
  endTime,
  createdAt,
  updatedAt,
  title,
  thumbnailUrl,
  id,
  isExchanged,
  getCouponById,
  disabled,
  couponlink,
}) => {
  const formatTime = (time) => moment(time * 1000).format("YYYY/MM/DD");
  return (
    <Wrapper>
      <MenuItem disabled={disabled} onClick={() => getCouponById(id)}>
        <div className="img-wrapper">
          <img alt="thumbnailUrl" src={thumbnailUrl} />
        </div>
        <div className="coupon_title">
          <Typography align="left" variant="subtitle1">
            {title}
          </Typography>
          <div>
            <Typography align="left" variant="subtitle1">
              <span className="coupon_tag">
                {isExchanged ? "已兌換" : "兌換期間"}
              </span>
              <span className="time_range">
                {isExchanged
                  ? `${formatTime(couponlink.redeemTime)}`
                  : `${formatTime(startTime)}-${formatTime(endTime)}`}
              </span>
            </Typography>
          </div>
        </div>
        <img src={ArrowRightIcon} width="10px" alt="arrow" />
      </MenuItem>
    </Wrapper>
  );
};

export default CouponListItem;
